import { useLocation } from 'react-router'
import { ReactElement, useEffect } from 'react'

export const ScrollToTop = (): ReactElement => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
